// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__3A5xu","bold":"Title_bold__3yB0O"};